// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"791":"a070c9513bea1763","1065":"5a8b2ed2269c8a13","8193":"2ca9a4cad954ee41"}[chunkId] + ".css";
};